import React, { FC } from "react";
import * as styles from "./Footer.module.scss";
import { SectionContainer } from "@silversea-ssc/ui-components-react";

import { FooterUrls } from "src/urls/footer_urls";
import SubFooter from "./components/SubFooter/SubFooter";

const FooterCDCDisclaimer = React.lazy(
  () => import("./components/FooterCDCDisclaimer/FooterCDCDisclaimer")
);
const BrandLogosFooter = React.lazy(
  () => import("./components/BrandLogosFooter/BrandLogosFooter")
);

interface FooterProps {
  urls: FooterUrls;
}

const FooterBase: FC<React.PropsWithChildren<FooterProps>> = ({ urls }) => {
  const { subFooterLinksLinks } = urls;

  return (
    <React.Fragment>
      <footer
        className={styles.footerLight}
        id="footer"
        data-content-name="footer"
      >
        <SectionContainer backgroundColor="transparent">
          <div className={styles.subFooter}>
            <SubFooter links={subFooterLinksLinks} />
          </div>
          <React.Suspense>
            <FooterCDCDisclaimer />
          </React.Suspense>
        </SectionContainer>
        <React.Suspense>
          <BrandLogosFooter />
        </React.Suspense>
      </footer>
    </React.Fragment>
  );
};

export const FooterLight = React.memo(FooterBase);
